import Form from "./Form";
import usePayment from "./hooks/usePayment";

export const Payment: React.FC = () => {
  const { ...props } = usePayment();

  return <Form {...props} />;
};
export default Payment;
